import { queryOptions, useQuery } from '@tanstack/react-query'

import { graphqlClient } from '../client'
import type { WhoAmIQuery } from '../codegen/graphql'
import { WhoAmI } from '../queries/whoAmI'

export const whoAmIQueryOptions = queryOptions({
  queryKey: ['whoAmI'],
  meta: {
    errorMessage: 'Failed to load current user',
    source: 'useWhoAmI',
  },
  queryFn: async () => {
    const response = await graphqlClient.request<WhoAmIQuery>(WhoAmI)
    return response.whoAmI
  },
  // User profile is stable within a session — no background refetch needed
  staleTime: Infinity,
})

export function useWhoAmI() {
  return useQuery(whoAmIQueryOptions)
}
